// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","content":"home_content__P-GDI","revoke":"home_revoke__vDSf8"};